import React from 'react';
import { Separator } from './ui/separator';
import { Linkedin } from 'lucide-react';
import { footerData } from '../data/mock';

export const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">
              Shine <span className="text-accent">Core Advisory LLC</span>
            </h3>
            <p className="text-primary-foreground/80 mb-4">
              Structured accounting and tax advisory for growing UAE businesses.
            </p>
            <div className="flex gap-3">
              <a
                href={footerData.socialLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-accent transition-colors p-2 rounded-lg"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-primary-foreground/80 hover:text-accent transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why-choose-us')}
                  className="text-primary-foreground/80 hover:text-accent transition-colors"
                >
                  Why Choose Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('founder')}
                  className="text-primary-foreground/80 hover:text-accent transition-colors"
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-primary-foreground/80 hover:text-accent transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2">
              {footerData.services.map((service, index) => (
                <li key={index}>
                  <span className="text-primary-foreground/80">
                    {service}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-primary-foreground/80">
              <li>{footerData.location}</li>
              <li>
                <a
                  href={`mailto:${footerData.email}`}
                  className="hover:text-accent transition-colors"
                >
                  {footerData.email}
                </a>
              </li>
              <li>
                <a
                  href={`tel:${footerData.phone}`}
                  className="hover:text-accent transition-colors"
                >
                  {footerData.phone}
                </a>
              </li>
              <li>
                <a
                  href="https://wa.me/971544223506"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-accent transition-colors inline-flex items-center gap-2"
                >
                  WhatsApp: {footerData.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-white/20" />

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-primary-foreground/70">
          <p>
            © {new Date().getFullYear()} Shine Core Advisory LLC. All rights reserved.
          </p>
          <div className="flex gap-6">
            <button className="hover:text-accent transition-colors">
              Privacy Policy
            </button>
            <button className="hover:text-accent transition-colors">
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
